import {
  Box_default
} from "./chunk-GDQZHQO7.js";
import {
  vs
} from "./chunk-56TZPABM.js";
import {
  React
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/layout/AbsoluteBox.tsx
import { forwardRef } from "react";
import cn from "classnames";

// packages/ui-lib/src/layout/AbsoluteBox.css.ts
var absolutePosition = "AbsoluteBox__1uw0mwt9";
var bottomVar = "var(--_1uw0mwt3)";
var heightVar = "var(--_1uw0mwt5)";
var leftVar = "var(--_1uw0mwt0)";
var position = { absolute: "AbsoluteBox_absolute__1uw0mwt7", fixed: "AbsoluteBox_fixed__1uw0mwt8" };
var rightVar = "var(--_1uw0mwt2)";
var topVar = "var(--_1uw0mwt1)";
var widthVar = "var(--_1uw0mwt4)";
var zIndexVar = "var(--_1uw0mwt6)";

// packages/ui-lib/src/layout/AbsoluteBox.tsx
var AbsoluteBox = forwardRef(({
  position: position2 = "absolute",
  children,
  left,
  top,
  zIndex,
  width,
  bottom,
  right,
  height
}, ref) => {
  const varStyles = vs([leftVar, left], [topVar, top], [bottomVar, bottom], [rightVar, right], [widthVar, width], [heightVar, height], [zIndexVar, zIndex]);
  const classNames = cn(position[position2], absolutePosition);
  return /* @__PURE__ */ React.createElement(Box_default, {
    ref,
    className: classNames,
    style: varStyles
  }, children);
});
var AbsoluteBox_default = AbsoluteBox;

export {
  AbsoluteBox_default
};
//# sourceMappingURL=chunk-7NUC72WS.js.map
